function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.414 7.031h-7.031a.586.586 0 00-.586.586V8.79c0 .97.788 1.758 1.758 1.758h1.758v2.493L4.687 16.206v-2.143h1.758a1.76 1.76 0 001.758-1.758v-1.172a.586.586 0 00-.586-.586H.586a.586.586 0 00-.586.586v1.172c0 .969.789 1.758 1.758 1.758h1.758v2.93c0 .39.378.673.753.56l5.145-1.533v2.808H7.656a.586.586 0 000 1.172h4.688a.586.586 0 000-1.172h-1.758v-3.157l5.48-1.633a.586.586 0 00.418-.561v-2.93h1.758A1.76 1.76 0 0020 8.789V7.617a.586.586 0 00-.586-.586z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.102 9.375a2.933 2.933 0 002.93-2.93 2.933 2.933 0 00-2.93-2.93 2.933 2.933 0 00-2.93 2.93 2.933 2.933 0 002.93 2.93zm0-3.516a.586.586 0 110 1.173.586.586 0 010-1.173zM15.977 5.86a2.933 2.933 0 002.93-2.93A2.933 2.933 0 0015.976 0a2.933 2.933 0 00-2.93 2.93 2.933 2.933 0 002.93 2.93zm0-3.516a.586.586 0 110 1.172.586.586 0 010-1.172z",
  fill: "#fff"
});

function SvgIconCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconCompare;